import { useState } from "react";
import styled from "styled-components";
import Column from "../components/Column/Column";
import Row from "../components/Row/Row";
import Text from "../components/Text/Text";
import playing_guitar_icon from "../imgs/playing_guitar_icon.svg";
import together_key_icon from "../imgs/together_key_icon.svg";
import {useLocation, useNavigate} from "react-router-dom"
import SimpleButton from "../components/Buttons/SimpleButton";
import ComposeLogoLink from "../components/Link/ComposeLogoLink";
import Song from "../songdetail/models/Song";

interface LicenseHubInfoProps {
  theme: string;
  toggleTheme: any;
}

interface LicenseHubState {
  song: Song;
}
const LicenseHubInfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: #000D30;
  background-size: cover;
  width: 99vw;
  height: 100vh;
  gap: 30px;
  align-items: center;
  flex-direction: column;
  padding-top: 3%;
`;

const InfoContainer = styled.div`
  display: flex;
  border: 0.5px solid #FFFFFF90;
  border-radius: 30px;
  width: 60%;
  max-height: 30%;
  gap: 20px;
  padding: 20px;
`;
const InfoText = styled(Text)`
  font-size: 18px;
`;
const TextColumn = styled(Column)`
  justify-content: space-evenly;
`;

const NextButton = styled(SimpleButton)`
  justify-content: end;
`;
const HalfRow = styled(Row)`
  width:60%;
  justify-content: end;
`;
export const LicenseHubInfo = ({ theme, toggleTheme }: LicenseHubInfoProps) => {
  const [showSecondPrompt, setShowSecondPrompt] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as LicenseHubState;

  const onNextClick = () => {
    if (!showSecondPrompt) {
      setShowSecondPrompt(true);
    } else {
      // go to next page
      navigate("/issue_license", {state: {song: locationState.song}});
    }
  };
  return (
    <>
    <ComposeLogoLink/>

      <LicenseHubInfoContainer>
        <Text bold={true}>License Hub</Text>

        <InfoContainer>
          <img src={playing_guitar_icon} />
          <TextColumn>
            <InfoText>
              As an artist, you deserve to be compensated for the reuse of your
              work.
            </InfoText>
            <InfoText>
              That's why ComposeNFT enables artists to sell Micro-Licenses for
              the use of their music.
            </InfoText>
          </TextColumn>
        </InfoContainer>
        {showSecondPrompt && (
          <InfoContainer>
            <img src={together_key_icon} />
            <TextColumn>
              <InfoText>
                Micro-licenses are “smaller” licenses for personal projects,
                indie films, and smaller productions.
              </InfoText>
              <InfoText>
                Micro-licenses are essentially a contractual agreement between
                you and the buyer, based on the terms set by you and agreed upon
                by both parties.
              </InfoText>
            </TextColumn>
          </InfoContainer>
        )}
        <HalfRow>
          {theme === "dark" ?
          <NextButton onClick={onNextClick} bg="primary">
            Next
          </NextButton> : 
          <SimpleButton bg="#07C0C6" onClick={onNextClick}>Next</SimpleButton>}
        </HalfRow>
      </LicenseHubInfoContainer>
    </>
  );
};
